import * as React from 'react'
import './styles.css'
import Glow from '../../glows'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { Themes, useTheme } from '../../../hooks/useTheme'
import CyberEssentialsLogo from '../../../assets/imgs/certifications/cyber-essentials.png'
import ISO42001Logo from '../../../assets/imgs/certifications/iso42001-removebg-preview.png'

const LINKS = [
  {
    title: 'About',
    link: '/team',
    target: '_blank',
  },
  {
    title: 'Contact',
    link: '/contact',
    target: '_blank',
  },
  {
    title: 'Careers',
    link: '/contact',
    target: '_blank',
  },
  {
    title: 'Security & Compliance',
    link: '/contact',
    target: '_blank',
  },
  {
    title: 'Privacy Policy',
    link: 'https://app.podglobal.com/privacy-policy/',
    target: '_blank',
  },
  {
    title: 'Terms of Use',
    link: 'https://app.podglobal.com/terms-and-conditions/',
    target: '_blank',
  },
]

const LINKS_EU = [
  {
    title: 'About',
    link: '/',
    target: '_blank',
  },
  {
    title: 'Contact',
    link: '/contact',
    target: '_blank',
  },
  {
    title: 'Security & Compliance',
    link: '/contact',
    target: '_blank',
  },
  {
    title: 'Privacy Policy',
    link: '/privacy-policy-uk',
    target: '_blank',
  },
]

const Footer = ({ theme, isEu }) => {
  const { theme: storeTheme } = useTheme()

  const isLightTheme = (theme || storeTheme) === Themes.LIGHT

  const links = isEu ? LINKS_EU : LINKS

  return (
    <footer
      className={classNames('footer', {
        'footer--light': isLightTheme,
      })}
    >
      <Glow position='bottom' />
      <div className='footer-links'>
        {links.map((item, index) =>
          item.target === '_blank' ? (
            <a key={index} href={item.link} target='_blank' rel='noreferrer'>
              {item.title}
            </a>
          ) : (
            <Link key={index} to={item.link} rel='noreferrer'>
              {item.title}
            </Link>
          )
        )}
      </div>

      {isEu && (
        <div className='footer-certifications'>
          <img
            src={CyberEssentialsLogo}
            alt='Cyber Essentials Certified'
            className='certification-logo'
          />
          {isLightTheme && (
            <img
              src={ISO42001Logo}
              alt='ISO/IEC 42001 Certification'
              className='certification-logo'
            />
          )}
        </div>
      )}

      <div className='footer-locations'>
        {!isEu && (
          <p>
            2321 Rosecrans Ave, Suite 5200,
            <br /> El Segundo, CA 90245{' '}
          </p>
        )}
        {isEu && (
          <p>
            118 Prospect Quay, 98 Point Pleasant,
            <br /> London SW18 1PR
          </p>
        )}
      </div>

      <div>
        {!isEu && (
          <p>
            &#169; 2026 Pod Network LLC. Patent Pending. Trademarks: Pod
            Matching Engine™, Pod Atlas™, Pod Intelligence Core™.
          </p>
        )}
        {isEu && <p>&#169; {new Date().getFullYear()} Pod Europe Ltd</p>}
      </div>
    </footer>
  )
}

export default Footer
